import React from "react";
import AllLinks from "./AllLinks";
const Links = () => {
  return (
    <div id="links-bar">
      <AllLinks />
    </div>
  );
};

export default Links;
